import { ThemedPressable, ThemedText, ThemedView } from '@app/theme'
import React, { useState } from 'react'
import LinearGradient from 'react-native-linear-gradient';
import { Image, Linking, StyleSheet } from 'react-native';
import { addCommasToNumber } from '@app/utils';
import LottieView from 'lottie-react-native';
import Button from '@app/sharedComponents/Button/Button';
import { CaretUp, CaretDown } from '../../../sharedComponents/Icons';
import { ThemedTouchableOpacity } from '@app/theme/Components';

const url =
    'https://wa.me/919611749097?text=Hi,%20I%20need%20Volt%20Money%20app%20link%20to%20withdraw%20from%20my%20credit%20line';




const FullRedirectionJourney = ({ approvedCreditLimit }: { approvedCreditLimit: number }) => {

    const [expanded, setExpanded] = useState(false);


    return (
        <>
            <ThemedView bg="bg-surface-primary" flex={1} padding='lg'>
                <LinearGradient
                    colors={['#12B76A', '#FFFFFF']}
                    start={{ x: 0, y: 0 }}
                    end={{ x: 0, y: 1 }}
                    style={{ flex: 0.5, borderRadius: 0 }}
                >
                    <ThemedView alignItems='center' flex={1} paddingHorizontal='lg'>
                        <Image source={{ uri: `https://volt-images-alpha.s3.ap-south-1.amazonaws.com/Frame+41.png` }} style={styles.voltImage} />
                        <LottieView
                            source={require('../../../../src/assets/lottie/phonepe_success.json')}
                            loop={true}
                            autoPlay={true}
                            style={{ width: 56, height: 56, marginTop: 24 }}
                        />
                        <ThemedText mt='xl' variant='h1b' color='text-success'>{`₹${addCommasToNumber(approvedCreditLimit)}`}</ThemedText>
                        <ThemedText mt='xs' variant='b2r' color='text-success'>Credit line opened successfully</ThemedText>

                        <ThemedView style={styles.card} borderRadius='lg' mt='5xl' alignSelf='stretch' bg='bg-surface-primary' padding='lg'>
                            <ThemedText mb='3xl' variant='h3s' color='text-primary'>Withdraw cash instantly on the Volt Money app</ThemedText>

                            <Button
                                label='Download Volt Money Now'
                                handlePress={() => {
                                    Linking.openURL(url);
                                }}
                            />
                            <ThemedView flexDirection='row' justifyContent='center' alignItems='center' mt='sm'>
                                <ThemedText color='text-secondary' variant='b4r'>Available on</ThemedText>
                                <Image
                                    source={{
                                        uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/play_store_icon.svg',
                                    }}
                                    style={styles.image}
                                ></Image>
                                <Image
                                    source={{
                                        uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/app_store_icon.svg',
                                    }}
                                    style={styles.image}
                                />
                            </ThemedView>
                        </ThemedView>
                        <ThemedView mb='2xl' alignSelf='stretch' mt='4xl' height={1} bg='border-primary' />
                        <ThemedView alignSelf='stretch'>
                            <ThemedText mb='md' variant='b4r' color='text-secondary'>FAQs</ThemedText>

                            <ThemedTouchableOpacity onPress={() => setExpanded(!expanded)}>
                                <ThemedView flexDirection='row' justifyContent='space-between' alignItems='center'>
                                    <ThemedText variant='b3b' color='text-primary'>How do I withdraw cash from my credit line?</ThemedText>
                                    {expanded ? <CaretUp /> : <CaretDown />}
                                </ThemedView>
                            </ThemedTouchableOpacity>

                            {expanded && (
                                <>
                                    <ThemedText mt='md' variant='b4r' color='text-secondary'>
                                        1. Download Volt Money app
                                    </ThemedText>
                                    <ThemedText variant='b4r' color='text-secondary'>
                                        2. Log in with your phone number
                                    </ThemedText>
                                    <ThemedText variant='b4r' color='text-secondary'>
                                        3. Click on the withdraw button
                                    </ThemedText>
                                    <ThemedText variant='b4r' color='text-secondary'>
                                        4. Get cash in your account in 4-5 business hours
                                    </ThemedText>
                                </>

                            )}


                        </ThemedView>
                    </ThemedView>

                </LinearGradient>

            </ThemedView>
        </>

    )
}

export default FullRedirectionJourney

const styles = StyleSheet.create({
    voltImage: {
        height: 20,
        width: 40,
        marginTop: 40
    },
    image: {
        width: 20,
        height: 20,
        marginLeft: 4,
    },
    card: {
        boxShadow:
            '0px 20px 40px 0px rgba(12, 25, 86, 0.08)',
        borderColor: 'rgba(241, 243, 245, 1)',
        borderStyle: 'solid',
        borderWidth: 1,
        backgroundColor: '#FFF',
        width: '100%',
    },
})